import { apiFetch } from "./client";

export const fetchVendorMeta = () =>
  apiFetch("/enduser/partner/meta/");

export const registerVendor = (payload) =>
  apiFetch("/enduser/partner/register/", {
    method: "POST",
    body: payload,
  });


